export const PRODUCT_COPY = {
  workflow: 'Workflow',
  workflows: 'Workflows',
  workflowLower: 'workflow',
  workflowsLower: 'workflows',
};

export function getProductCopy() {
  return PRODUCT_COPY;
}

export function getWorkflowTitle(playbookTitle) {
  if (!playbookTitle) {
    return PRODUCT_COPY.workflow;
  }

  const trimmedTitle = String(playbookTitle).trim();
  if (/\s+(playbook|workflow)$/i.test(trimmedTitle)) {
    return trimmedTitle.replace(/\s+(playbook|workflow)$/i, ` ${PRODUCT_COPY.workflow}`);
  }

  return `${trimmedTitle} ${PRODUCT_COPY.workflow}`;
}

export const EVENTS_WORKFLOW_COPY = {
  activation: {
    shortDescription: 'Get registrants engaged before the event starts.',
  },
};

export function getEventsWorkflowDescription(playbookType, fallbackDescription) {
  return EVENTS_WORKFLOW_COPY[playbookType]?.shortDescription || fallbackDescription;
}
